<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CreateModal from "./create";
import ClientListModal from "./clients_list";
import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'

export default {
  page: { 
    title: "Apartman Yönetimi",
    meta: [
      { 
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  mixins: [ datatableMixin],
  components: {
    Layout,
    PageHeader,
    CreateModal,
    ClientListModal,
    Datatable
  },
  data() {
    return { 
        title: "APARTMAN YÖNETİMİ",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "APARTMAN YÖNETİMİ",
            active: true,
          },
        ],

        searchParams: {},
        columns: [
            { name: '', key: 'action', orderable: false, width:10 },
            { name: 'Apartman Adı', key: 'name'},
            { name: 'İl', key: 'province' },
            { name: 'Bölge', key: 'quarter', className: 'text-end',orderable: true  },
        ],
        tableData: {
          detail: false,
          excel: true,
          searchable:{
              visible:true,
              placeholder:"Apartman Adı Ara"
          }
        },
        endpoint: '/apartman', 
        exportName: 'APARTMAN_LISTESI',

        list: {},
        selectApartment: {},
        openClientModal: 0,
        openCreateModal: 0,
    };
  },
  
  methods: {
    async loadPage() {
          
          this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
          
          const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
          if (this.params.page === 1) {
              this.tableData.data = response.data.data;
          } else {
              this.tableData.data = [...this.tableData.data, ...response.data.data];
          }
      
          this.tableData.pagination = {  current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total};
          this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
      },
          
    create(){
      this.list = {}
      this.openCreateModal+=1
      this.$parent.$bvModal.show('modal-scoped')
    },
    update(props){
      this.list = props
      this.openCreateModal+=1
      this.$parent.$bvModal.show('modal-scoped')
    },
    listOpen(props){
      this.selectApartment = { id:props.id, name:props.name }
      this.openClientModal+=1
      this.$parent.$bvModal.show('client-list-scoped')
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <CreateModal 
      :list="list" 
      :modelOpen="openCreateModal"/>

    <ClientListModal  
      :modelOpen="openClientModal"
      :apartmanetId="selectApartment.id" 
      :apartmentName="selectApartment.name" 
     />

     <div class="row"> 
      <div class="col-12">
        <Datatable 
              :columns="columns" 
              :tableData="tableData" 
              @sort-column="handleSortColumn"
              @search-query="reLoadPage"
              @excel-export="excelExport"
              :loading="isLoading"
              :poading="pageLoading">
          

          <template #button>
            <button class="btn btn-sm btn-success" @click="create()">Yeni Oluştur</button>
          </template>

          <template #action="{ row }">
            <b-dropdown
                toggle-class="font-size-16 p-0"
                toggle-tag="a"
                variant="white"
                append-to-body
                >
                <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <b-dropdown-item @click="update(row)">Güncelle</b-dropdown-item>
                  <b-dropdown-item @click="listOpen(row)"> Müşteri Listesi </b-dropdown-item>
              </b-dropdown> 
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>